<template>
  <div class="hearing-test">
   <div>
     <HeroBanner
         :background-image="bannerImage"
         title="무료 체험"
         sub-title="다비치 히어링 보청기 전국 매장에서는 <br>
        최대 한 달 보청기 무료 체험이 가능합니다."
     />
   </div>


   <!-- 보청기 적응 성공 노하우 Section -->
   <section class="adaptation-tips">
     <div class="adaptation-tips__container">
       <h2 class="adaptation-tips__title">보청기 적응 성공 노하우</h2>

       <div class="adaptation-tips__content">
         <!-- 첫 번째 원형 아이템 -->
         <div class="tip-item">
           <div class="tip-item__circle">
             <div class="tip-item__text">
               <div class="tip-item__heading">무료<br>청력 검사</div>
             </div>
           </div>
           <p class="tip-item__description">개인별 난청 상태, 유형 등<br>종합적 진단</p>
         </div>

         <!-- 두 번째 행 -->
         <div class="adaptation-tips__row">
           <div class="tip-item">
             <div class="tip-item__circle">
               <div class="tip-item__text">
                 <div class="tip-item__heading">무료<br>보청기 체험</div>
               </div>
             </div>
             <p class="tip-item__description">일주일부터 최대 한달까지<br>무료 체험 가능</p>
           </div>

           <div class="tip-item">
             <div class="tip-item__circle">
               <div class="tip-item__text">
                 <div class="tip-item__heading">무료<br>사후관리 A/S</div>
               </div>
             </div>
             <p class="tip-item__description">전국 어느 매장에서든<br>사후관리 A/S 무료</p>
           </div>
         </div>
       </div>
     </div>
   </section>

   <!-- 무료 체험 Section -->
   <section class="free-trial">
     <div class="free-trial__container">
       <div class="free-trial__header">
         <h2 class="free-trial__title">무료 체험</h2>
         <p class="free-trial__subtitle">다비치 히어링 보청기 전국 매장에서는<br>보청기 무료 체험이 가능합니다.</p>
       </div>

       <div class="free-trial__steps">
         <!-- Row 1 -->
         <div class="step-row">
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">1<br>무료 체험<br>신청하기</div>
             </div>
           </div>
           <div class="step-arrow">
             <img src="@/assets/images/banners/02/right-arrow2@x.png" alt="arrow" class="arrow-icon">
           </div>
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">2<br>가까운<br>매장 방문</div>
             </div>
           </div>
         </div>

         <!-- Row 2 -->
         <div class="step-row">
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">3<br>청력 검사<br>진행</div>
             </div>
           </div>
           <div class="step-arrow">
             <img src="@/assets/images/banners/02/right-arrow2@x.png" alt="arrow" class="arrow-icon">
           </div>
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">4<br>보청기 청음<br>및 착용</div>
             </div>
           </div>
         </div>

         <!-- Row 3 -->
         <div class="step-row">
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">5<br>보청기<br>이용 약관 안내</div>
             </div>
           </div>
           <div class="step-arrow">
             <img src="@/assets/images/banners/02/right-arrow2@x.png" alt="arrow" class="arrow-icon">
           </div>
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">6<br>보청기<br>체험 진행</div>
             </div>
           </div>
         </div>

         <!-- Row 4 -->
         <div class="step-row">
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">7<br>체험 중<br>궁금증 문의</div>
             </div>
           </div>
           <div class="step-arrow">
             <img src="@/assets/images/banners/02/right-arrow2@x.png" alt="arrow" class="arrow-icon">
           </div>
           <div class="step-item">
             <div class="step-item__circle">
               <div class="step-item__text">8<br>무료 체험<br>보청기 반납</div>
             </div>
           </div>
         </div>
       </div>

       <!-- 버튼 -->
        <div class="free-trial__buttons">
          <router-link to="/customer/consultation">
            <button class="btn btn--outline">간편 상담신청</button>
          </router-link>
          <router-link to="/customer/store-locator">
            <button class="btn btn--primary">방문 예약하기</button>
          </router-link>
       </div>
     </div>
   </section>
 </div>

</template>

<script>
import HeroBanner from "@/components/HeroBanner.vue";
import bannerBg from '@/assets/images/heros/02-top-img.png';
import bannerBg2 from '@/assets/images/heros/02-top-img@2x.png';
export default {
  name: 'HearingAidFreeTrial',
  components: {HeroBanner},
  data() {
    return {
      bannerImage: [bannerBg, bannerBg2],
    };
  }
};
</script>

<style scoped lang="scss">
.hearing-aid-types {
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
}

/* 보청기 적응 성공 노하우 Section */
.adaptation-tips {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  width: 100%;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    gap: 40px;
    width: 100%;
    max-width: 500px;
    margin: 60px auto;
  }

  &__title {
    width: 100%;
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 36px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    letter-spacing: -0.78px;
    color: #222222;
    margin: 0;
  }

  &__content {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 0;
    width: 100%;
  }

  &__row {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: flex-start;
    padding: 24px 0 0;
    gap: 16px;
    width: 100%;
  }
}

.tip-item {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 0;
  gap: 16px;
  width: 100%;
  max-width: 300px;

  &__circle {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 180px;
    height: 180px;
    min-width: 130px;
    min-height: 130px;
    border: 1.5px solid #222222;
    border-radius: 50%;
  }

  &__text {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
  }

  &__heading {
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: -0.02em;
    color: #222222;
  }

  &__description {
    width: 100%;
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 350;
    font-size: 18px;
    line-height: 30px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    letter-spacing: -0.04em;
    color: #222222;
    margin: 0;
  }
}

/* 무료 체험 Section */
.free-trial {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  padding: 60px 0;
  width: 100%;
  background: #F9F9F9;

  &__container {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0 20px;
    gap: 36px;
    width: 100%;
    max-width: 500px;
    margin: 0 auto;
  }

  &__header {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    gap: 12px;
    width: 100%;
  }

  &__title {
    width: 100%;
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 26px;
    line-height: 36px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    letter-spacing: -0.78px;
    color: #222222;
    margin: 0;
  }

  &__subtitle {
    width: 100%;
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 350;
    font-size: 15px;
    line-height: 24px;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    letter-spacing: -0.45px;
    color: #222222;
    margin: 0;
  }

  &__steps {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    gap: 20px;
    width: 100%;
  }

  &__buttons {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 0;
    gap: 12px;
    width: 100%;
    margin-top: 0px;
    a{
      width: 100%;
    }
  }
}

.step-row {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  padding: 0;
  gap: 5px;
  width: 100%;
}

.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  gap: 12px;

  &__circle {
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    padding: 10px;
    width: 200px;
    height: 200px;
    min-width: 140px;
    min-height: 140px;

    background: #F9F9F9;
    border: 1.5px solid #222222;
    border-radius: 50%;
  }

  &__text {
    font-family: 'Noto Sans KR', sans-serif;
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 26px;
    display: flex;
    align-items: center;
    text-align: center;
    letter-spacing: -0.54px;
    color: #222222;
  }
}

.step-arrow {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0;
  width: 24px;
  flex-shrink: 0;

  .arrow-icon {
    width: 25px;
    height: auto;
    object-fit: contain;
  }
}

.btn {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 0;
  width: 100%;
  height: 52px;
  font-family: 'Noto Sans KR', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 52px;
  text-align: center;
  cursor: pointer;
  border: none;
  outline: none;
  transition: all 0.3s ease;
  margin-top: 5px;

  &--outline {
    box-sizing: border-box;
    border: 1px solid #222222;
    background: transparent;
    color: #222222;

    &:hover {
      background: #f5f5f5;
    }
  }

  &--primary {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.2), rgba(0, 0, 0, 0.2)), #0056AA;
    color: #FFFFFF;
    border: none;

    &:hover {
      background: linear-gradient(0deg, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), #0056AA;
    }
  }
}

// =============================================================================
// 모바일 반응형 (450px 이하) - 더 작은 화면
// =============================================================================
@media (max-width: 450px) {
  .adaptation-tips {
    &__container {
      margin: 50px auto;
      gap: 32px;
    }

    &__title {
      font-size: 24px;
      line-height: 32px;
    }

    &__row {
      gap: 12px;
      padding-top: 20px;
    }
  }

  .tip-item {
    &__circle {
      width: 130px;
      height: 130px;
    }

    &__heading {
      font-size: 16px;
      line-height: 24px;
    }

    &__description {
      font-size: 14px;
      line-height: 22px;
    }
  }

  .free-trial {
    padding: 50px 0;

    &__container {
      gap: 28px;
    }

    &__title {
      font-size: 24px;
      line-height: 32px;
    }

    &__subtitle {
      font-size: 14px;
      line-height: 22px;
    }

    &__steps {
      gap: 16px;
    }
  }

  .step-item {
    &__circle {
      width: 120px;
      height: 120px;
    }

    &__text {
      font-size: 16px;
      line-height: 24px;
    }
  }

  .step-arrow {
    width: 20px;

    .arrow-icon {
      width: 16px;
    }
  }
}
</style>
